export const guests = [
  {
    id: 'guest-1',
    name: '林婉儿',
    nameEn: 'Waner Lin',
    age: 25,
    from: '中国上海',
    occupation: '时尚设计师',
    bio: '热爱生活，相信缘分天注定。期待在爱情岛找到那个能与我共度余生的灵魂伴侣。',
    imageSeq: 'guest-1',
  },
  {
    id: 'guest-2',
    name: '金泰妍',
    nameEn: 'Taeyeon Kim',
    age: 27,
    from: '韩国首尔',
    occupation: '音乐制作人',
    bio: '用音乐表达情感，用真心寻找爱情。我相信在这个美丽的岛屿上，会有奇迹发生。',
    imageSeq: 'guest-2',
  },
  {
    id: 'guest-3',
    name: '佐藤健太',
    nameEn: 'Kenta Sato',
    age: 28,
    from: '日本东京',
    occupation: '建筑设计师',
    bio: '设计过无数建筑，却从未设计过自己的爱情。希望在爱情岛亚洲找到那个让我心动的人。',
    imageSeq: 'guest-3',
  },
  {
    id: 'guest-4',
    name: '陈思雨',
    nameEn: 'Siyu Chen',
    age: 24,
    from: '中国台北',
    occupation: '插画师',
    bio: '用画笔描绘世界的美好，现在想用真心描绘一段真挚的爱情故事。',
    imageSeq: 'guest-4',
  },
  {
    id: 'guest-5',
    name: 'Raj Sharma',
    nameEn: 'Raj Sharma',
    age: 29,
    from: '印度孟买',
    occupation: '企业家',
    bio: '事业有成的我，现在最缺的就是一个能分享生活喜悦的伴侣。爱情岛，我来了！',
    imageSeq: 'guest-5',
  },
  {
    id: 'guest-6',
    name: 'Nguyen Mai',
    nameEn: 'Mai Nguyen',
    age: 26,
    from: '越南胡志明市',
    occupation: '舞蹈老师',
    bio: '舞蹈教会我用身体表达爱，现在我准备好用真心去感受爱了。',
    imageSeq: 'guest-6',
  },
  {
    id: 'guest-7',
    name: '李明浩',
    nameEn: 'Minghao Li',
    age: 30,
    from: '中国北京',
    occupation: '律师',
    bio: '在法庭上据理力争，在爱情面前我愿放下所有防备。真诚期待一段美好的相遇。',
    imageSeq: 'guest-7',
  },
  {
    id: 'guest-8',
    name: 'Arisa Tanaka',
    nameEn: 'Arisa Tanaka',
    age: 23,
    from: '日本大阪',
    occupation: '模特',
    bio: '走在聚光灯下的我，最渴望的是一份平凡而真挚的爱情。',
    imageSeq: 'guest-8',
  },
];

export const episodes = [
  {
    id: 'ep-1',
    title: '第一集：初见·心跳加速',
    season: '第一季',
    episodeNumber: 1,
    duration: '68分钟',
    releaseDate: '2026-07-15',
    description: '八位单身男女首次登上爱情岛，初次见面的紧张与期待交织。谁会成为第一对擦出火花的组合？',
    thumbnailSeq: 'ep-thumb-1',
  },
  {
    id: 'ep-2',
    title: '第二集：破冰·真心话大冒险',
    season: '第一季',
    episodeNumber: 2,
    duration: '72分钟',
    releaseDate: '2026-07-22',
    description: '嘉宾们通过真心话大冒险游戏加深了解，一场意外的告白让整个岛屿都沸腾了。',
    thumbnailSeq: 'ep-thumb-2',
  },
  {
    id: 'ep-3',
    title: '第三集：选择·心跳配对',
    season: '第一季',
    episodeNumber: 3,
    duration: '65分钟',
    releaseDate: '2026-07-29',
    description: '第一次配对仪式来临，每个人都要做出艰难的选择。有人甜蜜牵手，也有人黯然离场。',
    thumbnailSeq: 'ep-thumb-3',
  },
  {
    id: 'ep-4',
    title: '第四集：新人·惊喜降临',
    season: '第一季',
    episodeNumber: 4,
    duration: '70分钟',
    releaseDate: '2026-08-05',
    description: '两位新人突然空降爱情岛，打破了原有的平衡。旧情未了，新欢又来，岛屿风云再起。',
    thumbnailSeq: 'ep-thumb-4',
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '爱情岛亚洲第一季嘉宾阵容全揭秘',
    slug: 'season-1-cast-reveal',
    category: '节目资讯',
    excerpt: '爱情岛亚洲第一季正式公布全部嘉宾阵容，来自中国、日本、韩国、印度、越南等亚洲各国的魅力单身男女即将登岛。',
    content: '爱情岛亚洲第一季汇聚了来自全亚洲各地的八位魅力单身嘉宾。他们来自不同的文化背景，拥有各自的精彩人生故事。从上海的时尚设计师到东京的建筑师，从首尔的音乐制作人到孟买的企业家——这群多元化的嘉宾将在这个浪漫岛屿上谱写属于他们的爱情篇章。节目组表示，本季嘉宾经过层层筛选，每一位都拥有独特的个人魅力和真实的交友意愿。他们将在接下来的节目中经历初识、了解、心动、选择等真实的恋爱过程。',
    author: '编辑团队',
    publishDate: '2026-07-10',
    imageSeq: 'article-1',
    tags: ['嘉宾阵容', '第一季', '节目资讯'],
  },
  {
    id: 'article-2',
    title: '浪漫岛屿大揭秘：爱情岛拍摄地全攻略',
    slug: 'island-location-guide',
    category: '幕后花絮',
    excerpt: '爱情岛亚洲的拍摄地点选在东南亚一座绝美私人岛屿，碧海蓝天、椰林树影，堪称人间天堂。',
    content: '经过节目组近半年的实地考察，爱情岛亚洲最终选定了位于东南亚的一处私人岛屿作为拍摄地。这座岛屿拥有长达三公里的洁白沙滩，清澈见底的海水，以及茂密的热带植被。岛上建有豪华海景别墅群，每位嘉宾都将拥有独立的起居空间。公共区域包括无边泳池、露天餐厅、篝火晚会区和水上活动中心。节目组在保护自然环境的前提下，打造了一个兼具浪漫氛围和舒适生活的拍摄基地。',
    author: '编辑团队',
    publishDate: '2026-07-08',
    imageSeq: 'article-2',
    tags: ['拍摄地', '幕后花絮', '海岛'],
  },
  {
    id: 'article-3',
    title: '从陌生人到恋人：真人秀恋爱心理学分析',
    slug: 'reality-dating-psychology',
    category: '深度观察',
    excerpt: '为什么真人秀节目中的感情往往发展得比现实生活中更快？心理学家为你深度解析其中的奥秘。',
    content: '恋爱真人秀节目中，嘉宾们从陌生人到产生好感的平均时间往往只有几天甚至几小时，这一现象引发了许多观众的好奇。心理学家指出，这与几个关键因素密切相关：首先是"吊桥效应"——在紧张刺激的环境中，人们更容易将生理上的心跳加速误认为是心动的感觉。其次是"曝光效应"，密集的相处时间加速了亲密感的建立。最后是"社会促进效应"，在镜头和观众的关注下，人们更倾向于做出大胆的情感表达。',
    author: '心理专栏',
    publishDate: '2026-07-05',
    imageSeq: 'article-3',
    tags: ['心理学', '深度分析', '恋爱真人秀'],
  },
  {
    id: 'article-4',
    title: '爱情岛亚洲报名指南：如何成为下一季嘉宾',
    slug: 'how-to-apply',
    category: '报名指南',
    excerpt: '想要成为爱情岛亚洲的嘉宾？这里有最详细的报名流程和选拔标准，助你圆梦爱情岛。',
    content: '爱情岛亚洲面向全亚洲18-35岁的单身男女开放报名。报名流程分为四个阶段：在线申请、视频面试、心理评估和最终选拔。申请者需要提供个人基本信息、生活照片、自我介绍视频以及对理想伴侣的描述。节目组特别强调，他们寻找的是真诚希望寻找爱情的人，而非追求名利的参与者。选拔标准包括个人魅力值、情感表达能力、文化背景多样性以及真实的交友意愿。',
    author: '节目组',
    publishDate: '2026-06-28',
    imageSeq: 'article-4',
    tags: ['报名', '参与方式', '嘉宾选拔'],
  },
  {
    id: 'article-5',
    title: '亚洲恋爱文化对比：各国年轻人的爱情观',
    slug: 'asian-dating-culture',
    category: '深度观察',
    excerpt: '从含蓄到直率，从传统到现代，亚洲各国的恋爱观念正在经历前所未有的融合与碰撞。',
    content: '在中国，年轻一代的恋爱观正在从传统的"父母之命媒妁之言"向自由恋爱转变。日本年轻人则呈现出"草食系"趋势，对主动追求恋爱的热情有所下降。韩国的约会文化受到K-POP和韩剧的深刻影响，浪漫主义色彩浓厚。东南亚国家的年轻人则更注重家庭因素在恋爱中的分量。爱情岛亚洲恰好成为这些多元恋爱文化的交汇点，展现了一幅丰富多彩的亚洲情感图景。',
    author: '文化专栏',
    publishDate: '2026-06-20',
    imageSeq: 'article-5',
    tags: ['亚洲文化', '恋爱观', '文化对比'],
  },
  {
    id: 'article-6',
    title: '独家专访：爱情岛亚洲制作人谈节目初心',
    slug: 'producer-interview',
    category: '节目资讯',
    excerpt: '爱情岛亚洲执行制作人首次接受独家专访，分享节目诞生的背后故事和创作理念。',
    content: '在爱情岛亚洲开播前夕，我们有幸采访到了节目的执行制作人张伟。他分享道："亚洲拥有丰富的文化底蕴和多元的情感表达方式，但一直缺少一个真正面向全亚洲的恋爱真人秀平台。我们希望通过爱情岛亚洲，不仅展示浪漫的爱情故事，更展现亚洲年轻人的真实情感世界。"制作人还透露，第二季已经在筹备中，预计将扩大嘉宾阵容至十二人，并引入更多创新的互动环节。',
    author: '编辑团队',
    publishDate: '2026-07-01',
    imageSeq: 'article-6',
    tags: ['独家专访', '幕后故事', '制作人'],
  },
];

export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'program-news', name: '节目资讯', slug: 'program-news' },
  { id: 'behind-scenes', name: '幕后花絮', slug: 'behind-scenes' },
  { id: 'deep-dive', name: '深度观察', slug: 'deep-dive' },
  { id: 'apply-guide', name: '报名指南', slug: 'apply-guide' },
  { id: 'culture', name: '文化专栏', slug: 'culture' },
];

export const faqItems = [
  {
    question: '爱情岛亚洲是什么类型的节目？',
    answer: '爱情岛亚洲是一档面向全亚洲单身男女的沉浸式恋爱真人秀节目。节目汇集来自亚洲各国的魅力嘉宾，在浪漫的私人岛屿上共同生活，通过互动、约会、游戏等环节寻找真爱。节目真实记录嘉宾们的情感变化和恋爱历程。',
  },
  {
    question: '如何报名参加爱情岛亚洲？',
    answer: '您可以通过本网站的报名页面提交在线申请。报名流程包括：填写个人信息表、上传生活照片和自我介绍视频、参加视频面试以及心理评估。我们欢迎18-35岁的亚洲单身男女报名参加。报名通道每年春秋两季开放。',
  },
  {
    question: '在哪里可以观看爱情岛亚洲？',
    answer: '爱情岛亚洲在主流视频平台同步播出，包括优酷、爱奇艺、腾讯视频等。每周五晚8点更新最新一集。国际观众可以通过我们的官方YouTube频道观看英文字幕版本。',
  },
  {
    question: '节目是真实的还是剧本安排的？',
    answer: '爱情岛亚洲是一档真实恋爱真人秀，所有嘉宾的情感互动均为真实发生。节目组不干预嘉宾的情感选择，不提供剧本。我们是恋爱机会的创造者，而非爱情的导演。',
  },
  {
    question: '第一季共有多少集？每集多长时间？',
    answer: '爱情岛亚洲第一季共12集，每集时长约60-75分钟。此外还有每周更新的花絮特辑和嘉宾个人Vlog。节目从2026年7月15日首播，将持续至2026年9月底。',
  },
  {
    question: '节目拍摄地点在哪里？',
    answer: '爱情岛亚洲的拍摄地点位于东南亚一座私人岛屿，拥有绝美的海滩、热带植被和豪华别墅。出于隐私保护考虑，具体位置在节目播出期间不对外公开，但观众可以通过节目画面感受这座浪漫岛屿的魅力。',
  },
];

export const siteInfo = {
  name: '爱情岛亚洲',
  nameEn: 'Love Island Asia',
  description: '亚洲浪漫恋爱真人秀平台',
  fullDescription: '爱情岛亚洲是专为亚洲单身男女打造的沉浸式恋爱真人秀平台。我们汇聚来自中国、日本、韩国、印度、越南、泰国等亚洲各国的魅力嘉宾，在浪漫的热带岛屿上展开真实的爱情故事。节目以真诚、多元、浪漫为核心理念，致力于展现当代亚洲年轻人的真实情感世界。',
  brandStory: '爱情岛亚洲诞生于2025年，由一群热爱真人秀和亚洲文化的创作者共同发起。我们深信，亚洲拥有世界上最丰富多元的恋爱文化，却一直缺少一个能真实呈现这种多元性的舞台。于是我们决定打造这个平台——让来自不同国家、不同文化背景的年轻人，在一个平等、开放的环境中相遇、相知、相爱。',
  mission: '为全亚洲的单身男女创造真实、浪漫的相遇机会，同时通过节目展现亚洲多元文化的魅力。',
  vision: '成为亚洲最具影响力的恋爱真人秀品牌，让爱情跨越国界和文化。',
  contactPhone: '400-888-0000',
  contactEmail: 'hello@aiqingdao.asia',
  address: '中国上海市浦东新区世纪大道100号',
  socialMedia: {
    weibo: 'https://weibo.com/aiqingdaoasia',
    wechat: '爱情岛亚洲官方',
    instagram: 'https://www.instagram.com/aiqingdaoasia/',
    youtube: 'https://youtube.com/@loveislandasia',
    tiktok: 'https://www.tiktok.com/@aiqingdaoasia',
  },
};